import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import IconButton from '@material-ui/core/IconButton'
import useUploadFile from './useUploadFileTest'
import { UploadFileViewType, UploadFileType, NewReturnListFileType } from './uploadFileTypeTest'
import Grid from '@material-ui/core/Grid'
import { Typography, withStyles } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'

import useTranslate from '../../../../../i18n/useTranslate'

export type UplodeFileObjYype = {
    uploadFileObj: {
        documentTopicID: number
        fileList: {
            documentTopicID: number
            fileID: string
            fileToken: string
            filename: string
        }[]

        subTopicPageList?: {
            page: string
            documentTopicID: number
            subTopicID: number
        }[]
    }
}
const UploadFileView = (props: UploadFileViewType) => {
    const {
        disabled,
        required,
        label = '',
        name,
        field: { meta },
        refElementUpload,
        refElementTextField,
        onClickUpload,
        onChangeUpload,
        onClickClear,
        title,
        subTitleList,
        lstFileUpload,
        dataSource,
        topicID,
        initialData,
        onChangeInputPage,
    } = props
    const isError = !disabled && meta.error && meta.touched ? true : false
    const classes = useStyles(isError)
    const translate = useTranslate()
    const renderIcon = (file: NewReturnListFileType) => {
        return (
            <img
                src={process.env.PUBLIC_URL + '/img/icons/pdf.png'}
                alt="pdf"
                style={{ width: 24, height: 24, margin: 4, marginRight: 10 }}
            />
        )
    }
    return (
        <FormControl
            style={{
                width: '100%',
            }}
        >
            <Grid container>
                <Grid container item xs={10} justify={'flex-start'}>
                    <Typography variant={'body2'}>
                        {dataSource?.no}. {dataSource?.code} {dataSource?.name_th}{' '}
                    </Typography>
                </Grid>
                <Grid container item xs={2} justify={'flex-end'}>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={disabled}
                        onClick={onClickUpload}
                        size={'small'}
                    >
                        {translate.get('BUTTON.UPLOAD')}
                    </Button>
                </Grid>
                <Grid container item xs={12}>
                    {lstFileUpload?.map((itm: NewReturnListFileType) => {
                        return (
                            <Grid item xs={12}>
                                <Paper variant="outlined" style={{ padding: '5px', margin: '5px', marginRight: '0px' }}>
                                    <Grid container>
                                        <Grid container item xs={11} alignItems="center">
                                            {renderIcon(itm)}
                                            <Typography variant={'body2'}>
                                                {dataSource?.code} {itm.filename}
                                            </Typography>
                                        </Grid>
                                        <Grid container item xs={1} alignItems="center" justify={'flex-end'}>
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => {
                                                    onClickClear(itm)
                                                }}
                                            >
                                                <HighlightOffIcon color={'secondary'} />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        )
                    })}
                </Grid>
                {lstFileUpload && lstFileUpload.length > 0 && subTitleList && subTitleList.length > 0 && (
                    <Grid item container xs={12} style={{ margin: 10 }} spacing={1}>
                        <Grid item container xs={11} justify={'flex-start'}>
                            <Typography variant={'body2'}>
                                โปรดกรอกหน้าที่อยู่ของเอกสารดังนี้(กรณีไม่มีกรุณาเว้นว่างไว้){' '}
                            </Typography>
                        </Grid>
                        <Grid item container xs={1} justify={'flex-end'}>
                            <Typography variant={'body2'}>หน้า</Typography>
                        </Grid>
                        {subTitleList?.map((itm: any, index: number) => {
                            const uploadObj = initialData.filter(
                                (itm: UplodeFileObjYype) => itm.uploadFileObj.documentTopicID === topicID,
                            )
                            const initialSubtopic = uploadObj[0].uploadFileObj.subTopicPageList
                            return (
                                <>
                                    <Grid container item xs={11} justify={'flex-start'}>
                                        <Typography variant={'body2'}>{`${itm.no}.  ${itm.name_th}`}</Typography>
                                    </Grid>
                                    <Grid container item xs={1} justify={'flex-end'}>
                                        <TextField
                                            style={{ width: '60%' }}
                                            defaultValue={
                                                initialSubtopic && initialSubtopic[index]
                                                    ? initialSubtopic[index].page
                                                    : ''
                                            }
                                            variant={'outlined'}
                                            size={'small'}
                                            InputProps={{
                                                classes: {
                                                    input: classes.inputPage,
                                                },
                                            }}
                                            onChange={(e: any) => {
                                                onChangeInputPage(e.target.value, itm.id, dataSource?.id)
                                            }}
                                        />
                                    </Grid>
                                </>
                            )
                        })}
                    </Grid>
                )}
            </Grid>

            <input
                type="file"
                accept="image/png, image/jpeg,image/tiff,.pdf,.doc,.docx"
                name={name}
                id={name}
                multiple
                ref={refElementUpload}
                onChange={(e) => {
                    onChangeUpload(e, topicID)
                }}
                hidden
            />
            <TextField
                style={{ display: 'none' }}
                inputRef={refElementTextField}
                fullWidth
                // label={label}
                required={required}
                disabled={disabled}
                variant="outlined"
                autoComplete="off"
                size="small"
                error={isError} //{!disabled && meta.error && meta.touched ? true : false}
                InputLabelProps={{
                    shrink: true,
                }}
                InputProps={{
                    classes: {
                        root: classes.input,
                        adornedEnd: classes.button_end_icon,
                    },
                    endAdornment: (
                        <Grid
                            container
                            justify="flex-start"
                            alignContent="center"
                            style={{ width: '135px', flexWrap: 'nowrap' }}
                        ></Grid>
                    ),
                    readOnly: true,
                }}
                type="text"
            />
            <FormHelperText style={{ fontFamily: 'prompt', fontSize: '12px', color: '#ff4d4f' }}>
                {isError && meta.error}
            </FormHelperText>
        </FormControl>
    )
}

const UploadFile = (props: UploadFileType) => {
    const {} = props
    const uploadFileModel = useUploadFile(props)
    return <UploadFileView {...props} {...uploadFileModel} />
}

export default UploadFile

const useStyles = makeStyles((theme) => ({
    input: {
        '&>input': {
            cursor: 'default !important',
        },
    },
    button: {
        padding: '7px 16px',
        borderRadius: '0px 5px 5px 0px',
    },
    button_end_icon: {
        paddingRight: '0px',
    },
    clear_icon: {
        margin: theme.spacing(1),
    },
    label: {
        marginBottom: 10,
        color: (isError: any) => {
            if (isError) {
                return '#ff4d4f'
            } else {
                return ''
            }
        },
    },
    errorText: {
        fontSize: '12px',
        color: '#ff4d4f',
    },
    inputPage: {
        boxSizing: 'border-box',
        padding: '15px',
    },
}))
